/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    DatabaseAgileField,
    instanceOfDatabaseAgileField,
    DatabaseAgileFieldFromJSON,
    DatabaseAgileFieldFromJSONTyped,
    DatabaseAgileFieldToJSON,
} from './DatabaseAgileField';
import {
    DatabaseBasicField,
    instanceOfDatabaseBasicField,
    DatabaseBasicFieldFromJSON,
    DatabaseBasicFieldFromJSONTyped,
    DatabaseBasicFieldToJSON,
} from './DatabaseBasicField';
import {
    DatabaseCalcField,
    instanceOfDatabaseCalcField,
    DatabaseCalcFieldFromJSON,
    DatabaseCalcFieldFromJSONTyped,
    DatabaseCalcFieldToJSON,
} from './DatabaseCalcField';
import {
    DatabaseCategoryField,
    instanceOfDatabaseCategoryField,
    DatabaseCategoryFieldFromJSON,
    DatabaseCategoryFieldFromJSONTyped,
    DatabaseCategoryFieldToJSON,
} from './DatabaseCategoryField';
import {
    DatabaseChecklistField,
    instanceOfDatabaseChecklistField,
    DatabaseChecklistFieldFromJSON,
    DatabaseChecklistFieldFromJSONTyped,
    DatabaseChecklistFieldToJSON,
} from './DatabaseChecklistField';
import {
    DatabaseCombinedTextField,
    instanceOfDatabaseCombinedTextField,
    DatabaseCombinedTextFieldFromJSON,
    DatabaseCombinedTextFieldFromJSONTyped,
    DatabaseCombinedTextFieldToJSON,
} from './DatabaseCombinedTextField';
import {
    DatabaseCreatedByField,
    instanceOfDatabaseCreatedByField,
    DatabaseCreatedByFieldFromJSON,
    DatabaseCreatedByFieldFromJSONTyped,
    DatabaseCreatedByFieldToJSON,
} from './DatabaseCreatedByField';
import {
    DatabaseCreatedDateField,
    instanceOfDatabaseCreatedDateField,
    DatabaseCreatedDateFieldFromJSON,
    DatabaseCreatedDateFieldFromJSONTyped,
    DatabaseCreatedDateFieldToJSON,
} from './DatabaseCreatedDateField';
import {
    DatabaseCurrencyField,
    instanceOfDatabaseCurrencyField,
    DatabaseCurrencyFieldFromJSON,
    DatabaseCurrencyFieldFromJSONTyped,
    DatabaseCurrencyFieldToJSON,
} from './DatabaseCurrencyField';
import {
    DatabaseDateField,
    instanceOfDatabaseDateField,
    DatabaseDateFieldFromJSON,
    DatabaseDateFieldFromJSONTyped,
    DatabaseDateFieldToJSON,
} from './DatabaseDateField';
import {
    DatabaseEmailField,
    instanceOfDatabaseEmailField,
    DatabaseEmailFieldFromJSON,
    DatabaseEmailFieldFromJSONTyped,
    DatabaseEmailFieldToJSON,
} from './DatabaseEmailField';
import {
    DatabaseEntryLinkField,
    instanceOfDatabaseEntryLinkField,
    DatabaseEntryLinkFieldFromJSON,
    DatabaseEntryLinkFieldFromJSONTyped,
    DatabaseEntryLinkFieldToJSON,
} from './DatabaseEntryLinkField';
import {
    DatabaseEntryStatisticsField,
    instanceOfDatabaseEntryStatisticsField,
    DatabaseEntryStatisticsFieldFromJSON,
    DatabaseEntryStatisticsFieldFromJSONTyped,
    DatabaseEntryStatisticsFieldToJSON,
} from './DatabaseEntryStatisticsField';
import {
    DatabaseFileField,
    instanceOfDatabaseFileField,
    DatabaseFileFieldFromJSON,
    DatabaseFileFieldFromJSONTyped,
    DatabaseFileFieldToJSON,
} from './DatabaseFileField';
import {
    DatabaseImageField,
    instanceOfDatabaseImageField,
    DatabaseImageFieldFromJSON,
    DatabaseImageFieldFromJSONTyped,
    DatabaseImageFieldToJSON,
} from './DatabaseImageField';
import {
    DatabaseImageSeriesField,
    instanceOfDatabaseImageSeriesField,
    DatabaseImageSeriesFieldFromJSON,
    DatabaseImageSeriesFieldFromJSONTyped,
    DatabaseImageSeriesFieldToJSON,
} from './DatabaseImageSeriesField';
import {
    DatabaseLinkField,
    instanceOfDatabaseLinkField,
    DatabaseLinkFieldFromJSON,
    DatabaseLinkFieldFromJSONTyped,
    DatabaseLinkFieldToJSON,
} from './DatabaseLinkField';
import {
    DatabaseModifiedByField,
    instanceOfDatabaseModifiedByField,
    DatabaseModifiedByFieldFromJSON,
    DatabaseModifiedByFieldFromJSONTyped,
    DatabaseModifiedByFieldToJSON,
} from './DatabaseModifiedByField';
import {
    DatabaseModifiedDateField,
    instanceOfDatabaseModifiedDateField,
    DatabaseModifiedDateFieldFromJSON,
    DatabaseModifiedDateFieldFromJSONTyped,
    DatabaseModifiedDateFieldToJSON,
} from './DatabaseModifiedDateField';
import {
    DatabaseMultiFileField,
    instanceOfDatabaseMultiFileField,
    DatabaseMultiFileFieldFromJSON,
    DatabaseMultiFileFieldFromJSONTyped,
    DatabaseMultiFileFieldToJSON,
} from './DatabaseMultiFileField';
import {
    DatabaseNumberField,
    instanceOfDatabaseNumberField,
    DatabaseNumberFieldFromJSON,
    DatabaseNumberFieldFromJSONTyped,
    DatabaseNumberFieldToJSON,
} from './DatabaseNumberField';
import {
    DatabaseOwnerField,
    instanceOfDatabaseOwnerField,
    DatabaseOwnerFieldFromJSON,
    DatabaseOwnerFieldFromJSONTyped,
    DatabaseOwnerFieldToJSON,
} from './DatabaseOwnerField';
import {
    DatabaseParentEntryField,
    instanceOfDatabaseParentEntryField,
    DatabaseParentEntryFieldFromJSON,
    DatabaseParentEntryFieldFromJSONTyped,
    DatabaseParentEntryFieldToJSON,
} from './DatabaseParentEntryField';
import {
    DatabasePasswordField,
    instanceOfDatabasePasswordField,
    DatabasePasswordFieldFromJSON,
    DatabasePasswordFieldFromJSONTyped,
    DatabasePasswordFieldToJSON,
} from './DatabasePasswordField';
import {
    DatabasePercentageField,
    instanceOfDatabasePercentageField,
    DatabasePercentageFieldFromJSON,
    DatabasePercentageFieldFromJSONTyped,
    DatabasePercentageFieldToJSON,
} from './DatabasePercentageField';
import {
    DatabasePeriodField,
    instanceOfDatabasePeriodField,
    DatabasePeriodFieldFromJSON,
    DatabasePeriodFieldFromJSONTyped,
    DatabasePeriodFieldToJSON,
} from './DatabasePeriodField';
import {
    DatabaseRatingField,
    instanceOfDatabaseRatingField,
    DatabaseRatingFieldFromJSON,
    DatabaseRatingFieldFromJSONTyped,
    DatabaseRatingFieldToJSON,
} from './DatabaseRatingField';
import {
    DatabaseSequenceField,
    instanceOfDatabaseSequenceField,
    DatabaseSequenceFieldFromJSON,
    DatabaseSequenceFieldFromJSONTyped,
    DatabaseSequenceFieldToJSON,
} from './DatabaseSequenceField';
import {
    DatabaseTelnumberField,
    instanceOfDatabaseTelnumberField,
    DatabaseTelnumberFieldFromJSON,
    DatabaseTelnumberFieldFromJSONTyped,
    DatabaseTelnumberFieldToJSON,
} from './DatabaseTelnumberField';
import {
    DatabaseTextField,
    instanceOfDatabaseTextField,
    DatabaseTextFieldFromJSON,
    DatabaseTextFieldFromJSONTyped,
    DatabaseTextFieldToJSON,
} from './DatabaseTextField';
import {
    DatabaseVideoField,
    instanceOfDatabaseVideoField,
    DatabaseVideoFieldFromJSON,
    DatabaseVideoFieldFromJSONTyped,
    DatabaseVideoFieldToJSON,
} from './DatabaseVideoField';
import {
    DatabaseYesNoField,
    instanceOfDatabaseYesNoField,
    DatabaseYesNoFieldFromJSON,
    DatabaseYesNoFieldFromJSONTyped,
    DatabaseYesNoFieldToJSON,
} from './DatabaseYesNoField';

/**
 * @type UpdateFieldRequest
 * 
 * @export
 */
export type UpdateFieldRequest = { fieldType: 'AGILE_FIELD' } & DatabaseAgileField | { fieldType: 'BASIC_FIELD' } & DatabaseBasicField | { fieldType: 'CALC_FIELD' } & DatabaseCalcField | { fieldType: 'CATEGORY_FIELD' } & DatabaseCategoryField | { fieldType: 'CHECKLIST_FIELD' } & DatabaseChecklistField | { fieldType: 'COMBINED_TEXT_FIELD' } & DatabaseCombinedTextField | { fieldType: 'CREATED_BY_FIELD' } & DatabaseCreatedByField | { fieldType: 'CREATED_DATE_FIELD' } & DatabaseCreatedDateField | { fieldType: 'CURRENCY_FIELD' } & DatabaseCurrencyField | { fieldType: 'DATE_FIELD' } & DatabaseDateField | { fieldType: 'EMAIL_FIELD' } & DatabaseEmailField | { fieldType: 'ENTRY_LINK_FIELD' } & DatabaseEntryLinkField | { fieldType: 'FILE_FIELD' } & DatabaseFileField | { fieldType: 'IMAGE_FIELD' } & DatabaseImageField | { fieldType: 'IMAGE_SERIES_FIELD' } & DatabaseImageSeriesField | { fieldType: 'LINK_FIELD' } & DatabaseLinkField | { fieldType: 'MODIFIED_BY_FIELD' } & DatabaseModifiedByField | { fieldType: 'MODIFIED_DATE_FIELD' } & DatabaseModifiedDateField | { fieldType: 'MULTI_FILE_FIELD' } & DatabaseMultiFileField | { fieldType: 'NUMBER_FIELD' } & DatabaseNumberField | { fieldType: 'OWNER_FIELD' } & DatabaseOwnerField | { fieldType: 'PARENT_ENTRY_FIELD' } & DatabaseParentEntryField | { fieldType: 'PASSWORD_FIELD' } & DatabasePasswordField | { fieldType: 'PERCENTAGE_FIELD' } & DatabasePercentageField | { fieldType: 'PERIOD_FIELD' } & DatabasePeriodField | { fieldType: 'RATING_FIELD' } & DatabaseRatingField | { fieldType: 'SEQUENCE_FIELD' } & DatabaseSequenceField | { fieldType: 'STATISTICS_FIELD' } & DatabaseEntryStatisticsField | { fieldType: 'TELNUMBER_FIELD' } & DatabaseTelnumberField | { fieldType: 'TEXT_FIELD' } & DatabaseTextField | { fieldType: 'VIDEO_FIELD' } & DatabaseVideoField | { fieldType: 'YES_NO_FIELD' } & DatabaseYesNoField;

export function UpdateFieldRequestFromJSON(json: any): UpdateFieldRequest {
    return UpdateFieldRequestFromJSONTyped(json, false);
}

export function UpdateFieldRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFieldRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['fieldType']) {
        case 'AGILE_FIELD':
            return {...DatabaseAgileFieldFromJSONTyped(json, true), fieldType: 'AGILE_FIELD'};
        case 'BASIC_FIELD':
            return {...DatabaseBasicFieldFromJSONTyped(json, true), fieldType: 'BASIC_FIELD'};
        case 'CALC_FIELD':
            return {...DatabaseCalcFieldFromJSONTyped(json, true), fieldType: 'CALC_FIELD'};
        case 'CATEGORY_FIELD':
            return {...DatabaseCategoryFieldFromJSONTyped(json, true), fieldType: 'CATEGORY_FIELD'};
        case 'CHECKLIST_FIELD':
            return {...DatabaseChecklistFieldFromJSONTyped(json, true), fieldType: 'CHECKLIST_FIELD'};
        case 'COMBINED_TEXT_FIELD':
            return {...DatabaseCombinedTextFieldFromJSONTyped(json, true), fieldType: 'COMBINED_TEXT_FIELD'};
        case 'CREATED_BY_FIELD':
            return {...DatabaseCreatedByFieldFromJSONTyped(json, true), fieldType: 'CREATED_BY_FIELD'};
        case 'CREATED_DATE_FIELD':
            return {...DatabaseCreatedDateFieldFromJSONTyped(json, true), fieldType: 'CREATED_DATE_FIELD'};
        case 'CURRENCY_FIELD':
            return {...DatabaseCurrencyFieldFromJSONTyped(json, true), fieldType: 'CURRENCY_FIELD'};
        case 'DATE_FIELD':
            return {...DatabaseDateFieldFromJSONTyped(json, true), fieldType: 'DATE_FIELD'};
        case 'EMAIL_FIELD':
            return {...DatabaseEmailFieldFromJSONTyped(json, true), fieldType: 'EMAIL_FIELD'};
        case 'ENTRY_LINK_FIELD':
            return {...DatabaseEntryLinkFieldFromJSONTyped(json, true), fieldType: 'ENTRY_LINK_FIELD'};
        case 'FILE_FIELD':
            return {...DatabaseFileFieldFromJSONTyped(json, true), fieldType: 'FILE_FIELD'};
        case 'IMAGE_FIELD':
            return {...DatabaseImageFieldFromJSONTyped(json, true), fieldType: 'IMAGE_FIELD'};
        case 'IMAGE_SERIES_FIELD':
            return {...DatabaseImageSeriesFieldFromJSONTyped(json, true), fieldType: 'IMAGE_SERIES_FIELD'};
        case 'LINK_FIELD':
            return {...DatabaseLinkFieldFromJSONTyped(json, true), fieldType: 'LINK_FIELD'};
        case 'MODIFIED_BY_FIELD':
            return {...DatabaseModifiedByFieldFromJSONTyped(json, true), fieldType: 'MODIFIED_BY_FIELD'};
        case 'MODIFIED_DATE_FIELD':
            return {...DatabaseModifiedDateFieldFromJSONTyped(json, true), fieldType: 'MODIFIED_DATE_FIELD'};
        case 'MULTI_FILE_FIELD':
            return {...DatabaseMultiFileFieldFromJSONTyped(json, true), fieldType: 'MULTI_FILE_FIELD'};
        case 'NUMBER_FIELD':
            return {...DatabaseNumberFieldFromJSONTyped(json, true), fieldType: 'NUMBER_FIELD'};
        case 'OWNER_FIELD':
            return {...DatabaseOwnerFieldFromJSONTyped(json, true), fieldType: 'OWNER_FIELD'};
        case 'PARENT_ENTRY_FIELD':
            return {...DatabaseParentEntryFieldFromJSONTyped(json, true), fieldType: 'PARENT_ENTRY_FIELD'};
        case 'PASSWORD_FIELD':
            return {...DatabasePasswordFieldFromJSONTyped(json, true), fieldType: 'PASSWORD_FIELD'};
        case 'PERCENTAGE_FIELD':
            return {...DatabasePercentageFieldFromJSONTyped(json, true), fieldType: 'PERCENTAGE_FIELD'};
        case 'PERIOD_FIELD':
            return {...DatabasePeriodFieldFromJSONTyped(json, true), fieldType: 'PERIOD_FIELD'};
        case 'RATING_FIELD':
            return {...DatabaseRatingFieldFromJSONTyped(json, true), fieldType: 'RATING_FIELD'};
        case 'SEQUENCE_FIELD':
            return {...DatabaseSequenceFieldFromJSONTyped(json, true), fieldType: 'SEQUENCE_FIELD'};
        case 'STATISTICS_FIELD':
            return {...DatabaseEntryStatisticsFieldFromJSONTyped(json, true), fieldType: 'STATISTICS_FIELD'};
        case 'TELNUMBER_FIELD':
            return {...DatabaseTelnumberFieldFromJSONTyped(json, true), fieldType: 'TELNUMBER_FIELD'};
        case 'TEXT_FIELD':
            return {...DatabaseTextFieldFromJSONTyped(json, true), fieldType: 'TEXT_FIELD'};
        case 'VIDEO_FIELD':
            return {...DatabaseVideoFieldFromJSONTyped(json, true), fieldType: 'VIDEO_FIELD'};
        case 'YES_NO_FIELD':
            return {...DatabaseYesNoFieldFromJSONTyped(json, true), fieldType: 'YES_NO_FIELD'};
        default:
            throw new Error(`No variant of UpdateFieldRequest exists with 'fieldType=${json['fieldType']}'`);
    }
}

export function UpdateFieldRequestToJSON(value?: UpdateFieldRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['fieldType']) {
        case 'AGILE_FIELD':
            return DatabaseAgileFieldToJSON(value);
        case 'BASIC_FIELD':
            return DatabaseBasicFieldToJSON(value);
        case 'CALC_FIELD':
            return DatabaseCalcFieldToJSON(value);
        case 'CATEGORY_FIELD':
            return DatabaseCategoryFieldToJSON(value);
        case 'CHECKLIST_FIELD':
            return DatabaseChecklistFieldToJSON(value);
        case 'COMBINED_TEXT_FIELD':
            return DatabaseCombinedTextFieldToJSON(value);
        case 'CREATED_BY_FIELD':
            return DatabaseCreatedByFieldToJSON(value);
        case 'CREATED_DATE_FIELD':
            return DatabaseCreatedDateFieldToJSON(value);
        case 'CURRENCY_FIELD':
            return DatabaseCurrencyFieldToJSON(value);
        case 'DATE_FIELD':
            return DatabaseDateFieldToJSON(value);
        case 'EMAIL_FIELD':
            return DatabaseEmailFieldToJSON(value);
        case 'ENTRY_LINK_FIELD':
            return DatabaseEntryLinkFieldToJSON(value);
        case 'FILE_FIELD':
            return DatabaseFileFieldToJSON(value);
        case 'IMAGE_FIELD':
            return DatabaseImageFieldToJSON(value);
        case 'IMAGE_SERIES_FIELD':
            return DatabaseImageSeriesFieldToJSON(value);
        case 'LINK_FIELD':
            return DatabaseLinkFieldToJSON(value);
        case 'MODIFIED_BY_FIELD':
            return DatabaseModifiedByFieldToJSON(value);
        case 'MODIFIED_DATE_FIELD':
            return DatabaseModifiedDateFieldToJSON(value);
        case 'MULTI_FILE_FIELD':
            return DatabaseMultiFileFieldToJSON(value);
        case 'NUMBER_FIELD':
            return DatabaseNumberFieldToJSON(value);
        case 'OWNER_FIELD':
            return DatabaseOwnerFieldToJSON(value);
        case 'PARENT_ENTRY_FIELD':
            return DatabaseParentEntryFieldToJSON(value);
        case 'PASSWORD_FIELD':
            return DatabasePasswordFieldToJSON(value);
        case 'PERCENTAGE_FIELD':
            return DatabasePercentageFieldToJSON(value);
        case 'PERIOD_FIELD':
            return DatabasePeriodFieldToJSON(value);
        case 'RATING_FIELD':
            return DatabaseRatingFieldToJSON(value);
        case 'SEQUENCE_FIELD':
            return DatabaseSequenceFieldToJSON(value);
        case 'STATISTICS_FIELD':
            return DatabaseEntryStatisticsFieldToJSON(value);
        case 'TELNUMBER_FIELD':
            return DatabaseTelnumberFieldToJSON(value);
        case 'TEXT_FIELD':
            return DatabaseTextFieldToJSON(value);
        case 'VIDEO_FIELD':
            return DatabaseVideoFieldToJSON(value);
        case 'YES_NO_FIELD':
            return DatabaseYesNoFieldToJSON(value);
        default:
            throw new Error(`No variant of UpdateFieldRequest exists with 'fieldType=${value['fieldType']}'`);
    }

}

